"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _exportTaskApi = require("@/api/exportTaskApi");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var TASK_STATUS_COMPLETED = 'COMPLETED';
var TASK_STATUS_FAILED = 'FAILED';
var DEFAULT_POLL_INTERVAL = 2000;
var _default2 = exports.default = {
  name: 'AsyncExportButton',
  props: {
    type: {
      type: String,
      required: true
    },
    params: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    mode: {
      type: Number,
      default: undefined
    },
    batchSize: {
      type: Number,
      default: undefined
    },
    hidden: {
      type: Boolean,
      default: false
    },
    showProgressDialog: {
      type: Boolean,
      default: false
    },
    autoCloseDialog: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: '导出数据'
    },
    buttonType: {
      type: String,
      default: 'info'
    },
    size: {
      type: String,
      default: 'small'
    },
    icon: {
      type: String,
      default: 'el-icon-download'
    },
    buttonStyle: {
      type: [Object, Array, String],
      default: function _default() {
        return {};
      }
    },
    confirmText: {
      type: String,
      default: '确定要导出当前筛选条件下的数据吗？'
    },
    pollInterval: {
      type: Number,
      default: DEFAULT_POLL_INTERVAL
    }
  },
  data: function data() {
    return {
      loading: false,
      progress: 0,
      pollTimer: null,
      completionTimer: null,
      dialogVisible: false,
      statusText: '正在创建导出任务...',
      taskFailed: false
    };
  },
  computed: {
    mergedButtonStyle: function mergedButtonStyle() {
      return [{
        marginLeft: '8px'
      }, this.buttonStyle];
    },
    displayText: function displayText() {
      if (this.loading && this.progress > 0) {
        return "".concat(this.buttonText, " ").concat(this.progress, "%");
      }
      return this.buttonText;
    },
    progressStatus: function progressStatus() {
      if (this.taskFailed) {
        return 'exception';
      }
      return this.progress === 100 ? 'success' : undefined;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.clearPollTimer();
  },
  methods: {
    handleExport: function () {
      var _handleExport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var task, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return this.$confirm(this.confirmText, '确认导出', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
              });
            case 1:
              this.loading = true;
              this.progress = 0;
              this.taskFailed = false;
              this.statusText = '正在创建导出任务...';
              this.dialogVisible = this.showProgressDialog;
              _context.n = 2;
              return (0, _exportTaskApi.createExportTask)(this.buildTaskParams());
            case 2:
              task = _context.v;
              if (!(!task || !task.taskId)) {
                _context.n = 3;
                break;
              }
              throw new Error('创建导出任务失败');
            case 3:
              this.statusText = '导出任务处理中...';
              this.$emit('task-created', task);
              this.$message.success('导出任务已创建，正在处理中');
              this.pollTask(task.taskId);
              _context.n = 6;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              if (!(_t === 'cancel' || _t === 'close')) {
                _context.n = 5;
                break;
              }
              return _context.a(2);
            case 5:
              this.finishWithError(_t.message || '创建导出任务失败');
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[0, 4]]);
      }));
      function handleExport() {
        return _handleExport.apply(this, arguments);
      }
      return handleExport;
    }(),
    buildTaskParams: function buildTaskParams() {
      var taskParams = {
        type: this.type,
        params: _objectSpread({}, this.params)
      };
      if (this.mode !== undefined) {
        taskParams.mode = this.mode;
      }
      if (this.batchSize !== undefined) {
        taskParams.batchSize = this.batchSize;
      }
      return taskParams;
    },
    pollTask: function () {
      var _pollTask = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(taskId) {
        var _this = this;
        var task, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _exportTaskApi.getExportTaskStatus)(taskId);
            case 1:
              task = _context2.v;
              this.progress = task.progress || 0;
              this.statusText = task.status === 'PENDING' ? '导出任务等待处理...' : '导出任务处理中...';
              this.$emit('progress', task);
              if (!(task.status === TASK_STATUS_COMPLETED)) {
                _context2.n = 2;
                break;
              }
              this.finishSuccessfully(task);
              return _context2.a(2);
            case 2:
              if (!(task.status === TASK_STATUS_FAILED)) {
                _context2.n = 3;
                break;
              }
              this.finishWithError(task.errorMessage || '导出失败');
              return _context2.a(2);
            case 3:
              this.pollTimer = setTimeout(function () {
                return _this.pollTask(taskId);
              }, this.pollInterval);
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              this.finishWithError(_t2.message || '查询导出任务状态失败');
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 4]]);
      }));
      function pollTask(_x) {
        return _pollTask.apply(this, arguments);
      }
      return pollTask;
    }(),
    finishSuccessfully: function finishSuccessfully(task) {
      var _this2 = this;
      this.clearPollTimer();
      this.loading = false;
      this.progress = 100;
      this.statusText = '导出完成';
      if (!task.downloadUrl) {
        this.finishWithError('导出完成但未获取到下载地址');
        return;
      }
      window.open(task.downloadUrl);
      this.$message.success('导出成功');
      this.$emit('success', task);
      if (this.showProgressDialog && this.autoCloseDialog) {
        this.completionTimer = setTimeout(function () {
          _this2.dialogVisible = false;
          _this2.progress = 0;
        }, 1500);
      }
    },
    finishWithError: function finishWithError(message) {
      this.clearPollTimer();
      this.loading = false;
      this.taskFailed = true;
      this.statusText = message;
      this.dialogVisible = this.showProgressDialog;
      this.$message.error(message);
      this.$emit('error', message);
    },
    clearPollTimer: function clearPollTimer() {
      if (this.pollTimer) {
        clearTimeout(this.pollTimer);
        this.pollTimer = null;
      }
      if (this.completionTimer) {
        clearTimeout(this.completionTimer);
        this.completionTimer = null;
      }
    }
  }
};